<template>
  <div>
    <wc-page-title title='Accounts Receivable Report'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='6'>
          <wc-data-box
            title='Setup'
          >
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <wc-datepicker
                    label='As At Date'
                    v-model='as_at'
                    removeClearOption
                    defaultToday
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class='text-right py-0'>
                  <v-btn depressed class='primary' @click='generateReport' :loading='loadingItems'>Generate</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='3' v-if='generatedReport'>
          <wc-data-box
            title='Summary Results'
          >
            <v-card-text class='text-center'><h3 class='title'>{{ reportTotal | decMoney }}</h3></v-card-text>
          </wc-data-box>

        </v-col>
      </v-row>
      <v-row v-if='generatedReport'>
        <v-col cols='12' md='12'>
          <wc-data-box
            title='Details'
            showSearch
            v-model='search'
          >
            <v-data-table
              dense
              :items='processedInvoices'
              :headers='headers'
              :search='search'
              @click:row='openInvoice'
              sort-by='date_sent'
            >
              <template v-slot:item.date_sent='{ item }'>
                {{ $options.filters.shortDate(item.date_sent) }}
              </template>
              <template v-slot:item.original_amount='{ item }'>
                {{ item.original_amount | decMoney }}
              </template>
              <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | decMoney }}
              </template>
              <template v-slot:no-data>
                No results for selected date range.
              </template>
            </v-data-table>
            
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'revenue-report',
  data: () => ({
    as_at: moment().format('YYYY-MM-DD'),
    invoices: [],
    results: [],
    payments: [],
    processedInvoices: [],
    loadingItems: false,
    generatedReport: false,
    search: '',
    headers: [
      { text: 'Date Sent', value: 'date_sent' },
      { text: 'Bill To', value: 'bill_to_display' },
      { text: 'Invoice Total', value: 'original_amount', align: 'right' },
      { text: 'Amount OS', value: 'amount_os', align: 'right' }
    ]
  }),
  computed: {
    reportTotal () {
      return _.sumBy(this.processedInvoices, function (i) { return i.amount_os })
    }
  },
  methods: {
    async generateReport () {
      this.loadingItems = true
      this.results = []
      this.search = ''
      this.results = await accountingAPI.getARReport(this.as_at)
      this.payments = this.results.pmts
      this.processInvoices()
    },
    processInvoices () {
      console.log('processing invoices...')
      this.generatedReport = true
      let pmts = this.results.pmts
      if (pmts) {
        for (let i = 0; i < pmts.length; i++) {
          let tmp = this.results.invs.find(f => f.id === pmts[i].invoice)
          if (tmp) {
            tmp.amount_os += pmts[i].amount
          }
        }
      }
      this.processedInvoices = _.filter(this.results.invs, function (f) { return f.amount_os > 0 })
      console.log('done processing invoices...')
      this.loadingItems = false
    },
    openInvoice (item) {
      const routeData = this.$router.resolve({name: 'InvoiceOverview', params: { 'id': item.id }})
      window.open(routeData.href, '_blank')
    }
  }
}

</script>
